module.exports = __webpack_public_path__ + "img/table-minus-20x20.a8619bd3.svg";